var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:candle-sticks"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.0417 3.58301H35.8334V21.4997H34.0417V3.58301ZM13.4376 6.27051H15.2292V21.4997H13.4376V6.27051ZM7.16675 24.1872H8.95841V39.4163H7.16675V24.1872ZM25.0834 17.0205H26.8751V36.7288H25.0834V17.0205Z",
    fill: "#546E7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.2501 6.27051H37.6251C38.6105 6.27051 39.4167 7.07676 39.4167 8.06217V17.0205C39.4167 18.0059 38.6105 18.8122 37.6251 18.8122H32.2501C31.2647 18.8122 30.4584 18.0059 30.4584 17.0205V8.06217C30.4584 7.07676 31.2647 6.27051 32.2501 6.27051ZM11.6459 8.95801H17.0209C18.0063 8.95801 18.8126 9.76426 18.8126 10.7497V17.0205C18.8126 18.0059 18.0063 18.8122 17.0209 18.8122H11.6459C10.6605 18.8122 9.85425 18.0059 9.85425 17.0205V10.7497C9.85425 9.76426 10.6605 8.95801 11.6459 8.95801Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.37492 26.8747H10.7499C11.7353 26.8747 12.5416 27.6809 12.5416 28.6663V34.9372C12.5416 35.9226 11.7353 36.7288 10.7499 36.7288H5.37492C4.3895 36.7288 3.58325 35.9226 3.58325 34.9372V28.6663C3.58325 27.6809 4.3895 26.8747 5.37492 26.8747ZM23.2916 19.708H28.6666C29.652 19.708 30.4583 20.5143 30.4583 21.4997V32.2497C30.4583 33.2351 29.652 34.0413 28.6666 34.0413H23.2916C22.3062 34.0413 21.4999 33.2351 21.4999 32.2497V21.4997C21.4999 20.5143 22.3062 19.708 23.2916 19.708Z",
    fill: "#F44336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandles);
export default __webpack_public_path__ + "static/media/candles.bfcb6b89324212b0f05e374156382027.svg";
export { ForwardRef as ReactComponent };